var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLocateMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3637_41954)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.89,
    cy: 22.89,
    r: 22.89,
    fill: "url(#paint0_linear_3637_41954)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.89,
    cy: 22.89,
    r: 22.89,
    fill: "url(#paint1_radial_3637_41954)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4357 14.22C33.4357 14.22 33.4357 14.231 33.4357 14.2365L27.0697 35.2311C26.9734 35.5721 26.775 35.8755 26.5013 36.1005C26.2276 36.3256 25.8916 36.4615 25.5384 36.4901C25.4881 36.4945 25.4378 36.4967 25.3874 36.4967C25.0564 36.4977 24.7321 36.404 24.4526 36.2267C24.1731 36.0493 23.9502 35.7957 23.8102 35.4958L19.8287 27.325C19.7888 27.2432 19.7755 27.1509 19.7906 27.0611C19.8057 26.9713 19.8485 26.8884 19.9129 26.8241L26.2483 20.4887C26.4054 20.3233 26.4918 20.103 26.4889 19.8748C26.4859 19.6466 26.394 19.4286 26.2326 19.2672C26.0713 19.1059 25.8533 19.0139 25.6251 19.011C25.3969 19.0081 25.1766 19.0944 25.0112 19.2516L18.6725 25.587C18.6082 25.6514 18.5253 25.6941 18.4355 25.7092C18.3457 25.7243 18.2534 25.711 18.1715 25.6712L9.99309 21.6908C9.67328 21.5374 9.40765 21.2904 9.23138 20.9826C9.05511 20.6748 8.97654 20.3206 9.00608 19.9672C9.03561 19.6137 9.17186 19.2775 9.39677 19.0032C9.62167 18.7289 9.92462 18.5295 10.2655 18.4312L31.2601 12.0652H31.2765C31.5755 11.9813 31.8913 11.9783 32.1918 12.0567C32.4922 12.1351 32.7664 12.292 32.9862 12.5113C33.2059 12.7307 33.3634 13.0045 33.4424 13.3048C33.5214 13.6051 33.5191 13.921 33.4357 14.22Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3637_41954",
    x: -27.6,
    y: -27.6,
    width: 100.979,
    height: 100.98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3637_41954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3637_41954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3637_41954",
    x1: -18.0479,
    y1: 53.2633,
    x2: 89.7992,
    y2: -11.8852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#076193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#40A64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A975E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3637_41954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.289 100.018) rotate(-145.948) scale(312.308 104.712)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#65735A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#125F67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#3E4A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33696F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLocateMe);
export default __webpack_public_path__ + "static/media/Dark_LocateMe.2b5a94c70e9afabc061c764901d9ade6.svg";
export { ForwardRef as ReactComponent };